module.exports = __webpack_public_path__ + "static/media/keyicon-simplify-work.188be86c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature/keyicon-simplify-work.png
// module id = 85
// module chunks = 0